import React, { Component } from 'react'
import './events.scss'
import SessionCache from '../routes/session-cache'
import { ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import SchoolApi from '../../apis/school'
import EventList from './event-list/event-list'
import EventReport from './event-report/event-report'
import InviteStudents from '../class/invite-students-v2/invite-students-v2'
import InviteExistingStudents from '../class/invite-existing-students/invite-existing-students'
import { Modal, ModalBody } from 'reactstrap'
import EventDetails from './event-details/event-details'
import Loading from '../common/loading/loading'
import AddCoordinator from '../coordinators/add-new-coordinator/add-new-coordinator'
import Dropdown from '../common/dropdown-v2/dropdown'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component'
import SchoolUserApi from '../../apis/student'
import Path from '../routes/routes-path'
class Events extends Component {
  state = {
    selectedClass: 'All',
    showDetails: false,
    events: {
      active: [],
      completed: [],
      upcoming: []
    },
    selectedUsers: [],
    existingUsersDropdown: [],
    isSubmit: false,
    studentList: [],
  }

  constructor (props) {
    super(props)

    console.log(this.props)

  }

  componentDidMount () {
    this.getEvents()
    this.getStaffs()
    this.getStudent()
    this.getClassDetails()
  }


  getClassDetails() {
    let payload = { limit: 100 }

    SchoolApi.getClassAndBoard(payload)
      .then(school => {
        let classes = []
        for (let i = 0; i < school.classes.length; i++) {
          classes.push({
            title: school.classes[i].name,
            value: school.classes[i].name
          })
        }

        this.setState({ classes: classes })
      })
      .catch(err => { })
  }

  assignHomeworkByFixedConcept = (selectedClass = '') => {
    let userInfo = SessionCache.getUser()
    let classes = this.state.classes
    let classList = []
    classes.forEach(classDetail => {
      classList.push(classDetail.title)
    })

    if (selectedClass && selectedClass.class) {
      console.log('inside')
      classList = classList.filter(classItem => classItem === selectedClass.class)
    }

    console.log(classList)

    window.open(
      `/school/students/homework/assign/${userInfo.schoolInfo.schoolCode}/650aa3cdefd4fb045a339f0f?class=${classList.join(',')}`
    )
  }


  getStudent(payload = {}) {
    SchoolUserApi.getSchoolUsers(payload)
        .then(response => {
            this.setState({ studentList: response.response })
        }).catch(err => {
        })
  }

  showPerformanceReport = event => {
    this.setState({
      showEventDetails: false,
      showPerformanceReport: true,
      selectedEvent: event
    })
  }

  hidePerformanceReport = _ => {
    this.setState({
      showPerformanceReport: false,
      selectedEvent: null
    })
  }

  showEventDetails = (event, cardTitle) => {
    this.setState({
      showEventDetails: true,
      selectedEvent: event,
      cardTitle
    })
  }

  hideEventDetails = _ => {
    this.setState({
      showEventDetails: false,
      selectedEvent: null
    })
  }

  showInviteStudents = event => {
    this.setState({
      showInviteStudents: true,
      showInviteOption: false
    })
  }

  showInviteExistingStudents = event => {
    this.setState({
      showInviteExistingStudents: true,
      showInviteOption: false
    })
  }

  showInviteOption = event => {
    this.setState({
      showParticipateEvent: false,
      showInviteOption: true,
      selectedEvent: event
    })
  }

  showParticipateEvent = event => {
    this.setState({
      showParticipateEvent: true,
      selectedEvent: event
    })
  }

  hideParticipateEvent = _ => {
    this.setState({
      showParticipateEvent: false
    })
  }

  hideInviteOption = _ => {
    this.setState({
      showInviteOption: false
    })
  }

  hideInviteStudents = (success, message) => {
    if (success === true)
      this.showToaster(
        'info',
        message ? message : 'Message shared successfully on Whatsapp'
      )
    this.setState({
      showInviteStudents: false,
      showInviteExistingStudents: false
    })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  getEvents = _ => {
    let user = SessionCache.getUser()
    this.setState({
      isLoading: true
    })
    const eventParticipated = []
    if (user.schoolInfo?.eventParticipated?.length) {
      user.schoolInfo.eventParticipated.map(e => {
        eventParticipated.push(e.eventId)
        return e
      })
    }
    const payload = {
      schoolName: user.schoolInfo?.name,
      schoolLocality: user.schoolInfo?.address?.branch,
      eventParticipated,
      upcoming: true
    }
    SchoolApi.getEvents(payload)
      .then(response => {
        const { events } = this.state
        if (response.events) {
          response.events.map(e => {
            if (e.events.length) {
              events[e._id] = e.events
            }
            if (
              this.props?.location?.eventId &&
              this.props?.location?.showPerformance
            ) {
              const eventId = this.props?.location?.eventId
              const idx = e.events.findIndex(eve => eve._id === eventId)
              if (idx > -1 && e.events[idx]) {
                this.setState({
                  showPerformanceReport: true,
                  selectedEvent: e.events[idx]
                })
              }
            }
          })
        }
        this.setState({
          events,
          isLoading: false
        })
      })
      .catch(err => {
        this.setState({
          isLoading: false
        })
      })
  }

  addNewCoordinator = _ => {
    this.setState({
      showAddNewCoordinator: true
    })
  }

  hideAddNewCoordinator = _ => {
    this.setState(
      {
        showAddNewCoordinator: false
      },
      _ => {
        this.getStaffs()
      }
    )
  }

  getStaffs (payload = {}) {
    // payload.types = 'in/COORDINATOR'
    SchoolApi.getStaffs(payload)
      .then(response => {
        let items = []
        this.userHash = {}
        for (let i = 0; i < response?.response?.length; i++) {
          items.push({
            title: response?.response[i].firstName,
            value: response?.response[i]._id
          })
          this.userHash[response?.response[i]._id] = response?.response[i]
        }

        this.setState({ existingUsersDropdown: items, showDropdown: true })
      })
      .catch(err => {})
  }

  onSelectUser = options => {
    if (options?.length) {
      const selectedUsers = []
      options.map(o => selectedUsers.push(o.value))
      this.setState({ selectedUsers })
    }
  }

  onSave () {
    const { selectedEvent, selectedUsers, isSubmit } = this.state
    if (!selectedUsers?.length || isSubmit == true) {
      this.showInviteOption(selectedEvent)
    } else {
      const payload = { staffs: selectedUsers, eventId: selectedEvent._id }

      this.setState({ isSubmit: true })

      SchoolApi.updateEventsToCoordinator(payload)
        .then(response => {
          this.setState({ isSubmit: false }, _ => {
            this.showInviteOption(selectedEvent)
          })
        })
        .catch(err => {
          this.setState({ isSubmit: false })
        })
    }
  }

  renderParticipateEventModal () {
    const { selectedEvent } = this.state
    return (
      <Modal
        className='cw-custom-modal reject-modal'
        isOpen={true}
        toggle={this.hideParticipateEvent}
        size={'md'}
      >
        <ModalBody>
          <div className='row'>
            <div className='col text-right'>
              <img
                className='close-icon cursor-pointer'
                onClick={this.hideParticipateEvent}
                src={getImageSource(ImageConstants.CROSS)}
              />
            </div>
          </div>
          <div className='particpate-modal px-3'>
            <div className='title'>Participate in Event</div>
            <div className='sub-title'>{selectedEvent.title}</div>
            <div className='description mb-3'>
              {selectedEvent.participateInEventContent}
            </div>
            <div className='row mb-4'>
              <div className='col mt-4'>
                {!this.getEventParticipated(selectedEvent) ? (
                  <div className='text-center'>
                    <button
                      className={`cw-button-primary`}
                      onClick={this.onParticipateEvent}
                    >
                      I WANT TO PARTICIPATE IN THIS EVENT
                    </button>
                  </div>
                ) : (
                  <div>
                    <div className='sub-title text-center'>
                      Do you want to assign a coordinator to this event?
                    </div>
                    <div className='row mb-4'>
                      <div className='col-1'></div>
                      <div className='col-9 pr-0'>
                        {this.state.showDropdown && (
                          <Dropdown
                            key='users'
                            placeholder='Select from the list'
                            options={this.state.existingUsersDropdown}
                            onSelect={option => this.onSelectUser(option)}
                            text='title'
                            style={{ background: '#F6F7F5' }}
                            invalid={
                              this.state.isSubmit &&
                              !this.state.selectedUsers?.length
                            }
                            multiSelect={true}
                            value={this.state.selectedUsers}
                          />
                        )}
                      </div>
                      <div className='col-1 pl-0 my-auto'>
                        <img
                          className='custom-add-icon cursor-pointer'
                          onClick={() => this.addNewCoordinator()}
                          src={getImageSource(ImageConstants.ADD)}
                        />
                      </div>
                      <div className='col-1'></div>
                    </div>
                    <div className='text-center'>
                      <button
                        className={`cw-button-primary`}
                        onClick={_ => this.onSave()}
                      >
                        SAVE & INVITE FRIENDS
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }

  renderInviteOption () {
    const { selectedEvent, studentList } = this.state
    return (
      <Modal
        className='cw-custom-modal reject-modal invite-option'
        isOpen={true}
        toggle={this.hideInviteOption}
        size={'md'}
      >
        <ModalBody>
          <div className='row'>
            <div className='col text-right'>
              <img
                className='close-icon cursor-pointer'
                onClick={this.hideInviteOption}
                src={getImageSource(ImageConstants.CROSS)}
              />
            </div>
          </div>
          <div className='particpate-modal px-3'>
            <div className='title'>Invite Students</div>
            <div className='sub-title'>{selectedEvent.title}</div>
            <div className='description mb-3'>
              Invite your students to participate in this event via email or
              WhatsApp.
            </div>
            <div className='row mb-4 invite-buttons'>
              <div
                className='col text-center mt-4'
                onClick={this.showInviteStudents}
              >
                <button className={`cw-button-primary cw-btn-md2`}>
                  INVITE NEW STUDENTS
                </button>
              </div>
              {studentList.length > 0 &&
                <div
                  className='col text-center mt-4'
                  onClick={this.showInviteExistingStudents}
                >
                  <button className={`cw-button-primary`}>
                    INVITE EXISTING STUDENTS
                  </button>
                </div>
              }
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }

  onParticipateEvent = _ => {
    this.setState({
      isSubmit: true
    })
    const { selectedEvent } = this.state
    const payload = {
      eventId: selectedEvent._id
    }
    SchoolApi.addEventToSchool(payload)
      .then(response => {
        this.setState({
          isSubmit: false
        })
        let user = SessionCache.getUser()
        if (!user.schoolInfo.eventParticipated) {
          user.schoolInfo.eventParticipated = []
        }
        user.schoolInfo.eventParticipated.push({ eventId: selectedEvent._id })
        SessionCache.setUser(user)
        this.getEvents()
      })
      .catch(err => {
        this.setState({
          isSubmit: false
        })
      })
  }

  getEventParticipated = event => {
    let user = SessionCache.getUser()
    if (user.schoolInfo?.eventParticipated?.length) {
      const idx = user.schoolInfo.eventParticipated.findIndex(e => {
        return e.eventId === event._id
      })
      if (idx > -1) return true
      return false
    }
  }

  render () {
    const {
      showAddNewCoordinator,
      showInviteStudents,
      showParticipateEvent,
      showPerformanceReport,
      showInviteOption,
      events,
      selectedEvent,
      showInviteExistingStudents,
      showEventDetails,
      cardTitle
    } = this.state
    return (
      <div className='events'>
        {this.state.isLoading && <Loading />}
        {/* <div className='mb-5 cursor-pointer' onClick={_ => this.props.history.push({pathname: Path.STANDARD_HOMEWORK, showList: true})}> */}
        {/* <div className='mb-5 cursor-pointer' onClick={_ => this.assignHomeworkByFixedConcept()}>
          <img
            className='ad-banner'
            src={getImageSource(ImageConstants.SCHOOL_PORTAL_MSF_BANNER)}
          />
        </div> */}
        {!showPerformanceReport && !showEventDetails && (
          <div className='header-container'>
            <div className='pb-2'>
              <span className='screen-title'>Events</span>
            </div>
          </div>
        )}
        {!showPerformanceReport && !showEventDetails && (
          <div className=''>
            {events.active?.length > 0 && (
              <EventList
                data={events.active}
                showPerformanceReport={this.showPerformanceReport}
                showInviteStudents={this.showInviteStudents}
                showParticipateEvent={this.showParticipateEvent}
                showInviteOption={this.showInviteOption}
                showEventDetails={this.showEventDetails}
                title='Active'
              />
            )}
            {events.upcoming?.length > 0 && (
              <EventList
                data={events.upcoming}
                showPerformanceReport={this.showPerformanceReport}
                showInviteStudents={this.showInviteStudents}
                showInviteOption={this.showInviteOption}
                showEventDetails={this.showEventDetails}
                showParticipateEvent={this.showParticipateEvent}
                title='Upcoming'
              />
            )}
            {events.completed?.length > 0 && (
              <EventList
                data={events.completed}
                showPerformanceReport={this.showPerformanceReport}
                showEventDetails={this.showEventDetails}
                title='Completed'
                showParticipateEvent={this.showParticipateEvent}
              />
            )}
          </div>
        )}
        {!events.active?.length &&
          !events.upcoming?.length &&
          !events.completed?.length && (
            <div className='no-data text-center'>
              <img className='' src={getImageSource(ImageConstants.NO_DATA)} />
              <div className='no-events'>No Events Found</div>
            </div>
          )}
        {showPerformanceReport && selectedEvent && (
          <EventReport
            event={selectedEvent}
            closeReport={this.hidePerformanceReport}
          />
        )}
        {showEventDetails && selectedEvent && (
          <EventDetails
            event={selectedEvent}
            cardTitle={cardTitle}
            closeReport={this.hideEventDetails}
            showPerformanceReport={this.showPerformanceReport}
            showInviteStudents={this.showInviteStudents}
            showInviteOption={this.showInviteOption}
            getEventParticipated={this.getEventParticipated}
            showParticipateEvent={this.showParticipateEvent}
          />
        )}
        {showInviteStudents && (
          <InviteStudents event={selectedEvent} fromEvents={true} onClose={this.hideInviteStudents} />
        )}
        {showInviteExistingStudents && (
          <InviteExistingStudents
            event={selectedEvent}
            onClose={this.hideInviteStudents}
          />
        )}
        {showParticipateEvent && this.renderParticipateEventModal()}
        {showInviteOption && this.renderInviteOption()}
        {showAddNewCoordinator && (
          <AddCoordinator
            show={showAddNewCoordinator}
            onSave={this.hideAddNewCoordinator}
            onClose={this.hideAddNewCoordinator}
            size='lg'
          />
        )}
        {this.state.showToaster ? (
          <div className='custom-toaster-modal'>
            <ToasterComponent
              message={this.state.toasterMessage}
              type={this.state.toasterType}
              position='bottom-center'
            />
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default Events
